//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import MapaProdutosCrudList from './MapaProdutosCrudList';
import MapaProdutosEdit from './MapaProdutosEdit';
export default class MapaProdutosCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route path="/mapaProdutos" exact component={MapaProdutosCrudList} />
          <Route path="/mapaProdutos/novo" exact component={MapaProdutosEdit} />
          <Route path="/mapaProdutos/:id" component={MapaProdutosEdit} />
        </Switch>
      </React.Fragment>
    );
  }
}
